import { proxy, useSnapshot } from "valtio";
import { sendWarningReport } from "../reporting";
import { fetchTrustpilotScore } from "../../api/trustpilot";

const DEFAULT_TOTAL_REVIEWS = 123000;
const DEFAULT_SCORE_VALUE = 4.6;
const DEFAULT_TRUSTPILOT_LINK = "https://www.trustpilot.com/review/www.airhelp.com";

export const trustpilotScoreState = proxy({
  initialised: false,
  totalReviews: DEFAULT_TOTAL_REVIEWS,
  scoreValue: DEFAULT_SCORE_VALUE,
  trustpilotLink: DEFAULT_TRUSTPILOT_LINK,
});

export async function loadTrustpilotScore({
  forceReload = false,
  locale,
}: { forceReload?: boolean; locale?: string } = {}) {
  try {
    if (!trustpilotScoreState.initialised || forceReload) {
      const { totalReviews, scoreValue, trustpilotLink } = await fetchTrustpilotScore(locale);
      trustpilotScoreState.totalReviews = totalReviews;
      trustpilotScoreState.scoreValue = scoreValue;
      trustpilotScoreState.trustpilotLink = trustpilotLink;
      trustpilotScoreState.initialised = true;
    }
  } catch (e) {
    sendWarningReport("Failed to load trustpilot score", e);
  }
}

export function useTrustpilotScore() {
  const snapshot = useSnapshot(trustpilotScoreState);

  return {
    totalReviews: snapshot.totalReviews,
    scoreValue: snapshot.scoreValue,
    trustpilotLink: snapshot.trustpilotLink,
  };
}
